import application_settings from '../applicationSettings';
import Event from './Event';
import LocalStorage from '../local_data';

class GetLanguage extends Event {
    eventName = 'oms_getLanguage';

    constructor() {
        super();
        this.add();
    }

    /**
     * @override
     * 
     * Event Function for Get language
     * 
     * @return void
     *  
     */
    eventFunction(data) {
        let clientId = data.client_id;
        let thisObj = this;
        let requestId = (data.request_id) ? data.request_id : '';
        let action = (data.action) ? data.action : '';
        let clientLanguage = new LocalStorage.ClientLanguage(clientId);
        let language = clientLanguage.getData();
        if(language){
        thisObj.onSuccessEvent(thisObj.formatResponseData(language), {'action' : action, 'request_id' : requestId });
        }
        
        data.endPoint = application_settings.endPoints.getLanguage;
        
        this.sendRequest(data, function(response) {
            if (response) {
                let clientLanguage = new LocalStorage.ClientLanguage(clientId);

                //add data to storage
                clientLanguage.setData(response);

                //format response data
                let data = thisObj.formatResponseData(response);

                //fire success event
                thisObj.onSuccessEvent(data, {'action' : action, 'request_id' : requestId });
            }
        });
    }
}

export default GetLanguage;